import React from 'react';
import { Flex, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const EmptyAgentResult = () => {
	const { formatMessage } = useIntl();

	return (
		<Flex xcss={wrppaerStyles} alignItems="center" justifyContent="center">
			{formatMessage(messages.noResult)}
		</Flex>
	);
};

const wrppaerStyles = xcss({
	width: '100%',
	height: '120px',
});
